import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { getDefaultLanguage, translate } from '../services/translate';
import { useNavigationState } from '@react-navigation/native';
import UserInformationModal from '../components/UserInformationModal';
import { useAuth } from '../context/Auth';
import CustomButton from '../components/CustomButton';
import { useStyles } from 'react-native-unistyles';
import Card from '../components/Card';
import Container from '../components/Container';
import Header from '../components/Header';
import { RootNavigation } from '../Routes';
import { TermsLanguage } from '../schemas/documents';
import { documentService } from '../services/central-api/document';

interface SourceProps {
    html: string;
}

export default function TermsOfUse({ navigation }: { navigation: RootNavigation; }) {
    const { theme } = useStyles();

    const { user: authenticatedUser } = useAuth();
    const index = useNavigationState(state => state);
    const [showDropDown, setShowDropDown] = useState(false);
    const [source, setSource] = useState<SourceProps>({
        html: ''
    });
    const [termsVersionId, setTermsVersionId] = useState<number>();

    async function getTermsOfUse() {
        try {
            const language: TermsLanguage = getDefaultLanguage().toLowerCase().startsWith('en') ? 'en-us' : 'pt-br';
            const terms = await documentService.getCurrentTermsOfUseAndPrivacy('terms_of_use', language);
            setSource({ html: terms.htmlContent });
            setTermsVersionId(terms.id);
        } catch (err) {
            console.error(err);
        }
    }

    function goBack() {

        if (index.routes.length > 1) {
            return navigation.goBack();
        }

        navigation.navigate('Menu');
    }

    async function acceptTermsOfUse() {
        if (!termsVersionId) {
            return;
        }
        try {
            await documentService.acceptTermsOfUse(termsVersionId);
            navigation.navigate('Menu');
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getTermsOfUse();
    }, []);

    return (
        <Container>
            <Header title={translate('termsOfUse')} goBackAction={goBack} />
            <Card>
                <ScrollView >
                    <View style={{ flex: 1, maxWidth: 1000, alignSelf: 'center' }}>
                        <RenderHtml
                            source={source}
                            baseStyle={{ color: theme.colors.dataTable.actionIcon }}
                        />
                        {authenticatedUser && !authenticatedUser.acceptedTermsOfUse ?
                            <CustomButton
                                text={translate('iAcceptTermsOfUse')}
                                onPress={acceptTermsOfUse}
                            />
                            : null
                        }
                    </View>
                </ScrollView>
            </Card>
            <UserInformationModal
                showDropDown={showDropDown}
                setShowDropDown={setShowDropDown}
                navigation={navigation}
            />
        </Container>
    );
}
